<script setup lang="ts">
import type { ParsedFilterData } from '@autobid/strapi-integration/server/trpc/routers/auctions/auctionsFilter'
import type { Ref } from 'vue'
import { useAuctionStore } from '@autobid/nuxt-pinia-store/store/useAuctionStore'
import { Combobox } from '@headlessui/vue'
import { storeToRefs } from 'pinia'
import AuctionButtonsContainer from './AuctionButtonsContainer.vue'
import AuctionListFilterButton from './AuctionListFilterButton.vue'

const filterData = inject('filterData') as Ref<ParsedFilterData>

const auctionStoreKey = inject('auctionStoreKey')
const { filter } = storeToRefs(useAuctionStore(String(auctionStoreKey)))

function toggleAll() {
  filter.value.type
    = filter.value.type.length === filterData.value.types.length
      ? []
      : filterData.value.types as string[]
}
</script>

<template>
  <Combobox v-if="filterData" v-model="filter.type" multiple>
    <AuctionButtonsContainer static>
      <AuctionListFilterButton as="button" @click="toggleAll">
        {{ $t('auction-list.all') }}
      </AuctionListFilterButton>
      <AuctionListFilterButton
        v-for="type in filterData.types"
        :key="String(type)"
        :selected="filter.type.includes(String(type))"
        :value="type"
      >
        {{ String(type).toLowerCase() }}
      </AuctionListFilterButton>
    </AuctionButtonsContainer>
  </Combobox>
</template>
